/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as VerificationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.verification.grantVerifications'

export { $nsid }

/** Grant verifications to multiple subjects. Allows batch processing of up to 100 verifications at once. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    verifications: l.array(
      l.ref<VerificationInput>((() => verificationInput) as any),
      { maxLength: 100 },
    ),
  }),
  l.jsonPayload({
    verifications: l.array(
      l.ref<VerificationDefs.VerificationView>(
        (() => VerificationDefs.verificationView) as any,
      ),
    ),
    failedVerifications: l.array(l.ref<GrantError>((() => grantError) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output

type VerificationInput = {
  $type?: 'tools.ozone.verification.grantVerifications#verificationInput'

  /**
   * The did of the subject being verified
   */
  subject: l.DidString

  /**
   * Handle of the subject the verification applies to at the moment of verifying.
   */
  handle: l.HandleString

  /**
   * Display name of the subject the verification applies to at the moment of verifying.
   */
  displayName: string

  /**
   * Timestamp for verification record. Defaults to current time when not specified.
   */
  createdAt?: l.DatetimeString
}

export type { VerificationInput }

const verificationInput = l.typedObject<VerificationInput>(
  $nsid,
  'verificationInput',
  l.object({
    subject: l.string({ format: 'did' }),
    handle: l.string({ format: 'handle' }),
    displayName: l.string(),
    createdAt: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { verificationInput }

/** Error object for failed verifications. */
type GrantError = {
  $type?: 'tools.ozone.verification.grantVerifications#grantError'

  /**
   * Error message describing the reason for failure.
   */
  error: string

  /**
   * The did of the subject being verified
   */
  subject: l.DidString
}

export type { GrantError }

/** Error object for failed verifications. */
const grantError = l.typedObject<GrantError>(
  $nsid,
  'grantError',
  l.object({ error: l.string(), subject: l.string({ format: 'did' }) }),
)

export { grantError }
